import React, { Fragment } from 'react';
import { Image, Text, View, StyleSheet } from '@react-pdf/renderer';
import { findObjIntoArrayByProp, getBaseUrl, formatMoney } from '@iso/lib/helpers/utility';

import SemFoto from '@iso/assets/images/semFoto.png';

const borderColor = '#000000'
const styles = StyleSheet.create({
    row: {
        flexDirection: 'row',
        borderBottomColor: '#000000',
        borderBottomWidth: 1,
        alignItems: 'center',
        minHeight: 40,
        fontStyle: 'bold',
    },
    description: {
        width: '45%',
        textAlign: 'left',
        borderRightColor: borderColor,
        borderRightWidth: 1,
        paddingLeft: 8,
        overflow: 'wrap',
        height: '42px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'flex-start',
    },
    rate: {
        width: '17%',
        borderRightColor: borderColor,
        borderRightWidth: 1,
        textAlign: 'right',
        paddingRight: 8,
    },
    qty: {
        width: '8%',
        borderRightColor: borderColor,
        borderRightWidth: 1,
        textAlign: 'right',
        paddingRight: 8,
    },
    discount: {
        width: '13%',
        borderRightColor: borderColor,
        borderRightWidth: 1,
        textAlign: 'right',
        paddingRight: 8,
    },
    amount: {
        width: '17%',
        textAlign: 'right',
        paddingRight: '8px',
    },
    text: {
        fontSize: 8 // Defina o tamanho da fonte desejado,
    },
});

const ProposalTableRow = ({ items, products }) => {

    let BASE_URL = getBaseUrl();

    const getProductImage = (idItem) => {
        let productImage = null;

        try {
            let index = findObjIntoArrayByProp(products, '_id', idItem);

            if (index !== -1) {
                if (typeof products[index].images !== 'undefined' && products[index].images.length > 0) {

                    let principal = products[index].images.find(img => img.status === 'principal');
                    if (principal !== undefined)
                        productImage = principal
                    else
                        productImage = products[index].images[0]
                }
            }

            return productImage !== null ?
                <>
                    {
                        (
                            productImage.label.match(/.jpg/) || productImage.label.match(/.jpeg/) ||
                            productImage.label.match(/.png/) || productImage.label.match(/.gif/) ||
                            productImage.label.match(/.svg/) || productImage.label.match(/.webp/)
                        )
                            ?
                            <Image src={BASE_URL + '/display/send/images/' + productImage.fileName} alt={productImage.label} style={{ margin: '0px 2px 0 -2px', height: '40px' }} />
                            :
                            <Image src={SemFoto} style={{ maxWidth: '100%', maxHeight: '35px' }} />
                    }
                </>
                : <Image src={SemFoto} style={{ maxWidth: '100%', maxHeight: '35px' }} />
        } catch (error) {
            console.log(error);
        }
    }

    return (
        <Fragment>
            {items.map(item => {
                const quant = (item?.quantity) ? item.quantity : 0;
                const rt = (item?.unit_price) ? item.unit_price : 0;
                const disc = (item?.discount) ? item.discount : 0;
                // const description = (item?.item.name) ? item?.item.name : '';
                const description = (item?.name) ? item?.name : ((item?.item.name) ? item?.item.name : '');

                return (
                    (typeof item.item._id !== 'undefined') ?
                        <View style={styles.row} key={(item?.item?._id) ? item?.item?._id : 0}>
                            <View style={{ ...styles.description, flexDirection: 'row' }}>
                                {getProductImage(item.item._id)}
                                <Text style={styles.text}>
                                    {description}
                                </Text>
                            </View>
                            <Text style={{ ...styles.rate, ...styles.text }}>R$ {formatMoney(rt + '')}</Text>
                            <Text style={{ ...styles.text, ...styles.qty }}>{quant}</Text>
                            <Text style={{ ...styles.text, ...styles.discount }}>R$ {formatMoney(disc + '')}</Text>
                            <Text style={{ ...styles.text, ...styles.amount }}>R$ {formatMoney(((quant * rt) - (quant * disc)) + '')}</Text>
                        </View>
                        : ''
                )
            })}
        </Fragment>)
};

export default ProposalTableRow